module.exports = __webpack_public_path__ + "static/media/smarthygiene_pocp1.f0da982e.png";